import { render } from "./AdminNewsItem.vue?vue&type=template&id=3c3398ab&scoped=true"
import script from "./AdminNewsItem.vue?vue&type=script&lang=js"
export * from "./AdminNewsItem.vue?vue&type=script&lang=js"

import "./AdminNewsItem.vue?vue&type=style&index=0&id=3c3398ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3398ab"]])

export default __exports__